import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../utils/api';

// /sifre?t=... — davet veya şifre sıfırlama bağlantısı. Şifre belirlenince doğrudan giriş yapılır.
export default function SetPassword() {
  const [params] = useSearchParams();
  const token = params.get('t') || '';
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);       // { kind, name, email, expires_at }
  const [invalid, setInvalid] = useState(false);
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!token) { setInvalid(true); return; }
    api.get(`/auth/token/${encodeURIComponent(token)}`)
      .then(r => setInfo(r.data))
      .catch(() => setInvalid(true));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (pw.length < 8) return setError('Şifre en az 8 karakter olmalı');
    if (pw !== pw2) return setError('Şifreler aynı değil');
    setSaving(true);
    try {
      const r = await api.post('/auth/set-password', { token, password: pw }, { silent: true });
      localStorage.setItem('token', r.data.token);
      localStorage.setItem('user', JSON.stringify(r.data.user));
      // AuthContext localStorage'dan okur; tam yükleme ile oturum hazır gelir
      window.location.assign('/today');
    } catch (err) {
      setError(err.response?.data?.message || 'Şifre kaydedilemedi');
      if (err.response?.status === 404) setInvalid(true);
      setSaving(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg)', padding: 16 }}>
      <div className="card" style={{ width: '100%', maxWidth: 420, padding: 36 }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div className="brand brand--lg" style={{ cursor: 'default' }}>
            <span className="brand__word">BOLDRANKS</span>
            <span className="brand__sig">CRM</span>
          </div>
        </div>

        {invalid ? (
          <div style={{ textAlign: 'center' }}>
            <h2 style={{ fontSize: 18, margin: '0 0 8px' }}>Bağlantı geçersiz</h2>
            <p className="text-muted" style={{ fontSize: 14, lineHeight: 1.5 }}>
              Bu bağlantı daha önce kullanılmış ya da süresi dolmuş. Yöneticinizden yeni bir bağlantı isteyin
              veya giriş ekranındaki "Şifremi unuttum" ile yenisini alın.
            </p>
            <button className="btn btn--secondary" style={{ marginTop: 12 }} onClick={() => navigate('/login')}>Giriş ekranına dön</button>
          </div>
        ) : !info ? (
          <div className="text-muted" style={{ textAlign: 'center' }}>Bağlantı kontrol ediliyor…</div>
        ) : (
          <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div>
              <h2 style={{ fontSize: 18, margin: '0 0 4px' }}>
                {info.kind === 'invite' ? `Hoş geldin, ${String(info.name || '').split(' ')[0]}` : 'Yeni şifre belirle'}
              </h2>
              <p className="text-muted" style={{ fontSize: 13, margin: 0 }}>
                {info.email} · {info.kind === 'invite' ? 'Hesabın için bir şifre belirle.' : 'Eski şifren artık geçersiz olacak.'}
              </p>
            </div>
            <input className="form-input" type="password" autoComplete="new-password" placeholder="Şifre (en az 8 karakter)"
              value={pw} onChange={e => setPw(e.target.value)} required autoFocus />
            <input className="form-input" type="password" autoComplete="new-password" placeholder="Şifre (tekrar)"
              value={pw2} onChange={e => setPw2(e.target.value)} required />
            {error && <div style={{ color: 'var(--red)', fontSize: 13 }}>{error}</div>}
            <button className="btn btn--primary" type="submit" disabled={saving} style={{ justifyContent: 'center', padding: 12 }}>
              {saving ? 'Kaydediliyor…' : 'Şifreyi kaydet ve giriş yap'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
